<section class="new-installation-map" [class.embedded]="embedded"
  [class.device-details-open]="!!selectedLocation && !embedded"
  [style.--embedded-map-height]="embeddedHeight" [class.hide-map-labels]="!layers.labels">
  <header class="fullscreen-header">
    <div class="brand">
      <span class="brand-icon"><i class="fa fa-globe"></i></span>
      <strong>SIAC</strong><span class="divider"></span><strong>Mapa</strong>
      <span class="live"><i class="fa fa-circle"></i> En vivo</span>
    </div>

    <form class="search" (submit)="$event.preventDefault(); applySearch()">
      <i class="fa fa-search"></i>
      <input type="search" name="mapSearch" [(ngModel)]="search" (ngModelChange)="filtersChanged()"
             placeholder="Buscar instalación, ubicación o dispositivo...">
      <button type="submit" aria-label="Buscar"><i class="fa fa-arrow-right"></i></button>
    </form>

    <div class="header-actions">
      <button type="button" class="toolbar-button" (click)="filtersOpen = !filtersOpen">
        <i class="fa fa-filter"></i><span class="button-label">Filtros activos</span><b>{{selectedTypeCount}}</b>
      </button>
      <div class="layers-dropdown">
        <button type="button" class="toolbar-button" (click)="layersOpen = !layersOpen">
          <i class="fa fa-clone"></i><span class="button-label">Capas</span>
        </button>
        <div class="layers-menu" *ngIf="layersOpen">
          <label><input type="checkbox" [checked]="layers.pins" (change)="toggleLayer('pins')"> Dispositivos</label>
          <label><input type="checkbox" [checked]="layers.labels" (change)="toggleLayer('labels')"> Etiquetas</label>
          <label><input type="checkbox" [checked]="layers.zones" (change)="toggleLayer('zones')"> Zonas y líneas</label>
          <label><input type="checkbox" [checked]="layers.alarms" (change)="toggleLayer('alarms')"> Alarmas</label>
        </div>
      </div>
      <button type="button" class="icon-button" (click)="fitVisibleLocations()" title="Ajustar vista"><i class="fa fa-crosshairs"></i></button>
      <button *ngIf="!embedded" type="button" class="icon-button close-button" (click)="close()" title="Cerrar"><i class="fa fa-times"></i></button>
    </div>
  </header>

  <div class="map-surface">
    <app-installation-map
      *ngIf="visibleInstallations.length"
      [installationList]="visibleInstallations"
      [alarmList]="alarms"
      [zoneColorByLatestStatus]="true"
      [showLegend]="false"
      [showFullscreenButton]="false"
      [hideGoogleMapControls]="true"
      [selectionMode]="true"
      [showMapMarkers]="layers.pins"
      [showMapLines]="layers.zones"
      [mapHeight]="embedded ? embeddedHeight : 'calc(100dvh - 64px)'"
      (locationSelected)="selectLocation($event)">
    </app-installation-map>
    <div class="map-loading" *ngIf="!visibleInstallations.length">
      <ng-container *ngIf="!loaded; else loadedMapState"><i class="fa fa-spinner fa-spin"></i> Cargando instalaciones...</ng-container>
      <ng-template #loadedMapState>
        <span *ngIf="installationsError"><i class="fa fa-exclamation-triangle"></i> No fue posible cargar las instalaciones.</span>
        <span *ngIf="!installationsError">No hay ubicaciones que coincidan con los filtros.</span>
      </ng-template>
    </div>
  </div>

  <aside class="filter-panel" [class.collapsed]="!filtersOpen">
    <div class="map-type-switch">
      <button type="button" [class.active]="mapMode === 'roadmap'" (click)="setMapType('roadmap')">Mapa</button>
      <button type="button" [class.active]="mapMode === 'satellite'" (click)="setMapType('satellite')">Satélite</button>
    </div>
    <div class="panel-section">
      <div class="section-title"><strong>Tipos de dispositivos</strong><button type="button" (click)="toggleAllTypes()">{{allTypesSelected ? 'Ocultar todos' : 'Mostrar todos'}}</button></div>
      <button type="button" class="type-filter" *ngFor="let type of deviceTypes" [class.selected]="type.selected" (click)="toggleType(type)">
        <span class="check"><i class="fa" [ngClass]="type.selected ? 'fa-check' : ''"></i></span>
        <span class="type-icon"><i [class]="type.icon"></i></span>
        <span>{{type.name}}</span><b>{{type.count}}</b>
      </button>
      <p *ngIf="!deviceTypes.length">No hay tipos disponibles.</p>
    </div>
    <div class="panel-section legend">
      <div class="section-title"><strong>Leyenda</strong></div>
      <div *ngFor="let item of legend"><i [style.background]="item.color"></i><span>{{item.name}}</span></div>
      <div><i class="without-data"></i><span>Sin dispositivos</span></div>
    </div>
  </aside>

  <div class="map-summary" *ngIf="!embedded">
    <span>Mostrando <b>{{installationCount}}</b> instalaciones</span>
    <span><b>{{deviceCount}}</b> dispositivos</span>
    <span class="refresh">Actualizar en {{refreshCountdown}} s <i class="fa fa-refresh"></i></span>
  </div>

  <div class="embedded-map-legend" *ngIf="embedded" aria-label="Leyenda del estado de los dispositivos">
    <span *ngFor="let item of legend"><i [style.background]="item.color"></i>{{item.name}}</span>
    <span><i class="without-data"></i>Sin dispositivos</span>
  </div>

  <div class="map-controls">
    <button type="button" (click)="fitVisibleLocations()"><i class="fa fa-crosshairs"></i></button>
    <button type="button" (click)="zoom(1)"><i class="fa fa-plus"></i></button>
    <button type="button" (click)="zoom(-1)"><i class="fa fa-minus"></i></button>
  </div>

  <aside class="device-panel" *ngIf="selectedLocation && !embedded">
    <header class="device-panel-header">
      <small>Dispositivo seleccionado</small>
      <button type="button" (click)="closeSelection()" aria-label="Cerrar detalles"><i class="fa fa-times"></i></button>
      <div class="device-identity">
        <span class="device-avatar"><i class="fa fa-bolt"></i><img [src]="getLocationImage()" alt="" (error)="hideBrokenImage($event)"></span>
        <div>
          <h3>{{getDeviceName(selectedDevice)}}</h3>
          <p>{{getDeviceTypeName(selectedDevice, selectedDevice?.device_type_id)}} <i></i> {{selectedDeviceIdentifier}}</p>
          <div class="device-badges">
            <b class="status-badge" [class.alarm]="selectedDeviceAlarms.length">{{getStatus(selectedDevice)}}</b>
            <span class="alarm-badge" [class.alarm]="selectedDeviceAlarms.length">
              <i></i>{{selectedDeviceAlarms.length ? (selectedDeviceAlarms.length + ' ALARMAS') : 'SIN ALARMAS'}}
              <small>Último dato: {{lastCommunicationLabel}}</small>
            </span>
          </div>
        </div>
      </div>
      <label class="device-select" *ngIf="selectedLocation.Devices?.length > 1">
        <select [ngModel]="selectedDevice?.id" (ngModelChange)="selectDeviceById($event)" aria-label="Dispositivo en esta ubicación">
          <option *ngFor="let device of selectedLocation.Devices" [ngValue]="device.id">{{getDeviceName(device)}}</option>
        </select>
      </label>
    </header>
    <nav>
      <button type="button" [class.active]="panelTab === 'summary'" (click)="panelTab = 'summary'">Resumen</button>
      <button type="button" [class.active]="panelTab === 'events'" (click)="panelTab = 'events'">Eventos</button>
      <button type="button" [class.active]="panelTab === 'status'" (click)="panelTab = 'status'">Estado</button>
    </nav>
    <div class="panel-content" [ngSwitch]="panelTab">
      <div *ngSwitchCase="'summary'" class="device-summary">
        <section class="device-section">
          <h4>Estado actual</h4>
          <div class="current-state" [class.alarm]="selectedDeviceAlarms.length">
            <i class="fa" [ngClass]="selectedDeviceAlarms.length ? 'fa-exclamation-triangle' : 'fa-check'"></i>
            <span><b>{{devicePanelState}}</b><small>{{devicePanelStateDescription}}</small></span>
          </div>
        </section>
        <section class="device-section">
          <h4>Ubicación</h4>
          <div class="location-card">
            <i class="fa fa-map-marker"></i>
            <span><b>{{selectedLocation.name || 'Ubicación sin nombre'}}</b><small>{{selectedInstallationName}}</small></span>
            <button type="button" (click)="focusSelectedLocation()">Ver en mapa <i class="fa fa-arrow-right"></i></button>
          </div>
        </section>
        <section class="device-section">
          <h4>Indicadores de salud</h4>
          <div class="health-list">
            <div *ngFor="let indicator of healthIndicators">
              <span>{{indicator.label}}</span><b>{{indicator.value}}</b><i [attr.data-health]="indicator.health"></i>
            </div>
          </div>
        </section>
        <section class="device-section">
          <h4>Última comunicación</h4>
          <div class="communication-card"><i class="fa fa-clock-o"></i><span><b>{{lastCommunicationLabel}}</b><small>{{(getLatestSensorDate() | date:'dd/MM/yyyy HH:mm:ss') || 'Sin datos'}}</small></span></div>
        </section>
        <section class="device-section monitored-asset">
          <h4>Activo monitoreado</h4>
          <!-- Fotos de instalación en carrusel; sin fotos se muestra el icono del activo. -->
          <div class="asset-photos" [class.has-photos]="photoSlides.length">
            <ng-container *ngIf="photoSlides.length; else assetIcon">
              <img *ngFor="let slide of photoSlides; let i = index" class="installation-photo" [class.active]="i === photoIndex"
                   [src]="slide.url" [alt]="'Foto de instalación ' + slide.photo">
              <ng-container *ngIf="photoSlides.length > 1">
                <button type="button" class="photo-nav prev" aria-label="Foto anterior" (click)="showPreviousPhoto()">‹</button>
                <button type="button" class="photo-nav next" aria-label="Foto siguiente" (click)="showNextPhoto()">›</button>
                <div class="photo-dots">
                  <button type="button" *ngFor="let slide of photoSlides; let i = index" [class.active]="i === photoIndex"
                          [attr.aria-label]="'Ver foto ' + slide.photo" (click)="photoIndex = i"></button>
                </div>
              </ng-container>
            </ng-container>
            <ng-template #assetIcon>
              <img [src]="getLocationImage()" alt="Imagen del activo" (error)="hideBrokenImage($event)">
              <span class="photo-loading" *ngIf="photosLoading"><i class="fa fa-spinner fa-spin"></i></span>
            </ng-template>
          </div>
        </section>
      </div>
      <div *ngSwitchCase="'events'" class="device-events">
        <div class="events-heading"><h4>Eventos</h4><span>Últimas 24 horas <i class="fa fa-angle-down"></i></span></div>
        <div class="current-state compact" [class.alarm]="selectedDeviceAlarms.length">
          <i class="fa" [ngClass]="selectedDeviceAlarms.length ? 'fa-exclamation-triangle' : 'fa-check'"></i>
          <span><b>{{selectedDeviceAlarms.length ? 'ALARMAS ACTIVAS' : 'SIN ALARMAS ACTIVAS'}}</b><small>{{devicePanelStateDescription}}</small></span>
        </div>
        <h4 class="recent-title">Historial reciente</h4>
        <div class="events-list">
          <button type="button" *ngFor="let alarm of selectedDeviceAlarms | slice:0:6" (click)="openAlarm(alarm)">
            <i class="fa fa-bell"></i><span><b>{{getAlarmTitle(alarm)}}</b><small>Tipo de activo: {{getAlarmAssetType(alarm)}}</small><small>Tipo de alarma: {{getAlarmSensorType(alarm)}}</small><small>{{formatRelativeDate(alarm.create_date)}} · {{alarm.create_date | date:'HH:mm'}}</small></span><em>Activa</em>
          </button>
          <div class="events-empty" *ngIf="!selectedDeviceAlarms.length"><i class="fa fa-check-circle"></i><span><b>Estado normal</b><small>No se registran alarmas activas.</small></span></div>
        </div>
        <button type="button" class="full-history" (click)="goToAlarms()">Ver historial completo <i class="fa fa-arrow-right"></i></button>
      </div>
      <div *ngSwitchCase="'status'" class="device-status-content">
        <p *ngIf="sensorsLoading"><i class="fa fa-spinner fa-spin"></i> Cargando datos actuales...</p>
        <details class="sensor-group" *ngFor="let group of sensorGroups" [open]="group.open">
          <summary><span><i class="fa" [ngClass]="group.icon"></i>{{group.label}}</span><i class="fa fa-angle-down"></i></summary>
          <div class="sensor-row" *ngFor="let sensor of group.sensors">
            <span>{{getSensorLabel(sensor)}}</span><b>{{getSensorValue(sensor)}}</b><i [attr.data-health]="getSensorHealth(sensor)"></i>
          </div>
          <p *ngIf="!group.sensors.length">Sin datos disponibles.</p>
        </details>
      </div>
    </div>
    <footer>
      <button type="button" class="primary" (click)="openDetail()"><i class="fa fa-external-link"></i> Ver detalle</button>
      <button type="button" (click)="panelTab = 'events'"><i class="fa fa-history"></i> Ver historial</button>
    </footer>
  </aside>

  <section class="alarm-strip" [class.empty]="!latestAlarms.length">
    <header><span>Alarmas activas en vista <b>{{alarmsInView.length}}</b></span><button type="button" (click)="goToAlarms()">Ver todas <i class="fa fa-arrow-right"></i></button></header>
    <div *ngIf="latestAlarms.length; else emptyAlarms">
      <button type="button" class="alarm-card" *ngFor="let alarm of latestAlarms" (click)="openAlarm(alarm)">
        <i class="alarm-icon fa fa-bell"></i>
        <span><b>{{getAlarmTitle(alarm)}}</b><small>{{getAlarmLocation(alarm)}}</small><small>Tipo de activo: {{getAlarmAssetType(alarm)}}</small><small>Tipo de alarma: {{getAlarmSensorType(alarm)}}</small><small>{{alarm.create_date | date:'dd-MM-yyyy HH:mm'}}</small></span>
        <em>{{getAlarmSeverity(alarm)}}</em>
      </button>
    </div>
    <ng-template #emptyAlarms>
      <div class="alarm-empty-state">
        <span class="empty-alarm-icon"><i class="fa" [ngClass]="alarmsError ? 'fa-exclamation-triangle' : 'fa-check'"></i></span>
        <span *ngIf="alarmsError"><b>No fue posible cargar las alarmas</b><small>Se conservará la última información disponible.</small></span>
        <span *ngIf="!alarmsError"><b>Sin alarmas activas</b><small>No hay alarmas para los dispositivos visibles en el mapa.</small></span>
      </div>
    </ng-template>
  </section>
</section>
